export default __webpack_public_path__ + "static/media/Alert2.df846e53.svg";